/* eslint-disable camelcase */
import React from 'react';
import '../../../../common/components/Modal/v2/Modal.scss';
import {Fade, Modal} from '@mui/material';

const _ModalSideBar = ({isOpen, onClose}) => {
  if (!isOpen) return null;

return (
    <>
        <Modal open={isOpen} onClose={onClose} closeAfterTransition>
            <Fade in={isOpen}>
                <div className="modal-content">
                    <button className="modal-close-button" onClick={onClose}>
                        ✕
                    </button>
                    <div className="modal-title-3">
                        <h2 className="h3">¡Estrenamos nuevo sitio!</h2>
                    </div>
                    <div className="modal-body-1">
                        <p className="body-1 ">
                            Actualizamos el sitio a{' '}
                            <a href="https://validador-prestaciones.contigosalud.com.ar" target="_blank" rel="noopener noreferrer">
                                https://validador-prestaciones.contigosalud.com.ar
                            </a>
                            .
                            <br/>
                            Aprende a familiarizarte con el nuevo diseño con este breve manual de uso.
                        </p>
                    </div>

                    <div className="modal-subtitle-1" style={{margin: '8px 0'}}>
                        <p className="subtitle-1 ">
                            Guía rápida de cómo usar la nueva página:
                        </p>
                    </div>

                    <iframe width="560" height="315" src="https://www.youtube.com/embed/3vjO46vyX4U?si=CNiz9im6tbOGG7v_"
                            title="YouTube video player" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
            </Fade>
        </Modal>
    </>
);
};

export default _ModalSideBar;
